import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const withdrawalHistorySchema = z.object({
  /** withdraw id */
  id: z.string(),
  /** txId */
  txId: z.string().nullable(),
  /** coin */
  coin: z.string(),
  /** withdraw network */
  network: z.string(),
  /** withdraw address */
  address: z.string(),
  /** withdraw amount */
  amount: decimalSchema,
  /** transferType, 0: outside transfer, 1: inside transfer */
  transferType: z.number(),
  /** withdraw status, 1: APPLY, 2: AUDITING, 3: WAIT, 4: PROCESSING, 5: WAIT_PACKAGING, 6: WAIT_CONFIRM, 7: SUCCESS, 8: FAILED, 9: CANCEL, 10: MANUAL */
  status: z.number(),
  /** transactionFee */
  transactionFee: decimalSchema,
  /** confirmNo */
  confirmNo: z.number().nullable(),
  /** apply time (timestamp) */
  applyTime: z.number().int(),
  /** remark */
  remark: z.string(),
  /** memo */
  memo: z.string().nullable(),
  /** transaction Hash */
  transHash: z.string(),
  /** update time (timestamp) */
  updateTime: z.number().int(),
  /** asset id */
  coinId: z.string().optional(),
  /** currency id */
  vcoinId: z.string().optional(),
})

export const responseSchema = z.array(withdrawalHistorySchema)
